import React, { useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await API.post("/signin", { email, password });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      localStorage.setItem("user_id", res.data.user.user_id);
      localStorage.setItem("username", res.data.user.username);
      localStorage.setItem("role", res.data.user.role);
      console.log("User role stored in localStorage:", res.data.user.username, res.data.user.role, res.data.user.user_id, res.data.user);

      if (res.data.user.role === "admin") {
        localStorage.setItem("role", 1);
      } else if (res.data.user.role === "lead") {
        localStorage.setItem("role", 2);
      }

      const role = res.data.user.role;

      if (role === "admin") {
        navigate("/AdminDashboard");
      } else if (role === "hr") {
        navigate("/HrDashboard");
      } else if (role === "lead") {
        navigate("/LeadDashboard");
      }

    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    }
  };


  return (
    <div className="login-wrapper">

      {/* LEFT FULL IMAGE */}
      <div className="login-left">
        <img src="/Side-img.png" alt="Attendance Illustration" />
      </div>

      {/* RIGHT LOGIN FORM */}
      <div className="login-right">
        <img src="/Softmate-Logo.png" className="logo" alt="Softmate" />

        <form onSubmit={handleLogin} className="login-form">
          <h1 style={{ textAlign: "center" }}>Login In</h1>

          <div className="form-group">
            <label>Email ID</label>
            <div className="input-box">
              <span className="icon">📧</span>
              <input
                type="email"
                placeholder="Enter Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Password</label>

            <div className="input-box">
              <span className="icon">🔑</span>

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>
          </div>




          <button type="submit">Login</button>

          <p style={{ textAlign: "center", marginTop: "15px" }}>
            Don't have an account?{" "}
            <span
              style={{ color: "#007bff", cursor: "pointer" }}
              onClick={() => navigate("/signup")}
            >
              Create Account
            </span>
          </p>

        </form>
      </div>

    </div>
  );
}
